module.exports = __webpack_public_path__ + "static/media/logo.fw.front.5dde2106.png";